import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

const titleHr ={
     border: ".009em solid #e13024",
     width: "100%",
     marginTop: "-5px",
     direction:"rtl",
     textAlign:"right"
}

const LawsInside = props => {
     return props.size === "laptopdesktop" ? (
          <div className="LawsInsideBackground">
               <div style={{paddingTop:"75px"}}>
                    <Center>
                         <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft"><strong>قوانین بیمه مرکزی ایران</strong></p>
                    </Center>
               </div>
               <Row style={{marginTop:"100px"}}>
                    <Col span={4}></Col>
                    <Col span={16}>
                         <Card style={{ borderRadius: "20px", backgroundColor: "#fff" ,opacity:"90%"}}>
                              <Row>
                                   <Col span={24}>
                                        <p style={{direction:"rtl" , textAlign:"right"}} className="cardTitle">
                                        <strong>
                                             {props.title}
                                        </strong>
                                        </p>
                                        <hr style={titleHr} />
                                   </Col>
                              </Row>
                              <div style={{backgroundColor:"#fff"}}>
                                   <p className="textParagraph">
                                        {props.text}
                                   </p>
                              </div>
                         </Card>
                    </Col>
                    <Col span={4}></Col>
               </Row>
        </div>
     ) : props.size === "tablet" ? (
          <div className="LawsInsideBackground">
               <div style={{ paddingTop: "75px" }}>
                    <Center>
                         <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"><strong>قوانین بیمه مرکزی ایران</strong></p>
                    </Center>
               </div>
               <Row style={{ marginTop: "100px" }}>
                    <Col span={2}></Col>
                    <Col span={20}>
                         <Card style={{ borderRadius: "20px", backgroundColor: "#fff", opacity: "90%" }}>
                              <Row>
                                   <Col span={24}>
                                        <p style={{ direction: "rtl", textAlign: "right" }} className="cardTitleTablet">
                                             <strong>
                                                  {props.title}
                                             </strong>
                                        </p>
                                        <hr style={titleHr} />
                                   </Col>
                              </Row>
                              <div style={{ backgroundColor: "#fff" }}>
                                   <p className="textParagraphTablet">
                                        {props.text}
                                   </p>
                              </div>
                         </Card>
                    </Col>
                    <Col span={2}></Col>
               </Row>
          </div>
     ) : (
          <div className="LawsInsideBackground">
               <div style={{ paddingTop: "50px" }}>
                    <Center>
                         <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile" style={{color:"#fff"}}><strong>قوانین بیمه مرکزی ایران</strong></p>
                    </Center>
               </div>
               <Row style={{ marginTop: "50px" }}>
                    <Col span={1}></Col>
                    <Col span={22}>
                         <Card style={{ borderRadius: "20px", backgroundColor: "#fff", opacity: "90%" }}>
                              <Row>
                                   <Col span={24}>
                                        <p style={{ direction: "rtl", textAlign: "right" }} className="cardTitleMobile">
                                             <strong>
                                                  {props.title}
                                             </strong>
                                        </p>
                                        <hr style={titleHr} />
                                   </Col>
                              </Row>
                              <div style={{ backgroundColor: "#fff" }}>
                                   <p className="textParagraphMobile">
                                        {props.text}
                                   </p>
                              </div>
                         </Card>
                    </Col>
                    <Col span={1}></Col>
               </Row>
          </div>
          );
};

export default LawsInside;
